import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';

const AdminViewCustomer = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [customerDetails, setCustomerDetails] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});

  const user = JSON.parse(localStorage.getItem('user'))
  const email = user.email

 
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'))
    const email = user.email
    
    const fetchCustomerDetails = async () => {
      try {
        const response = await axios.get(`https://citi-mobile-app.onrender.com/admin/viewuser/${id}/${email}`);
          setCustomerDetails(response.data);
        setFormData(response.data); // Initialize form data
      } catch (error) {
        console.error('Error fetching customer details:', error);
      }
    };

    fetchCustomerDetails();
  }, [id]);

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleEditClick = () => {
    setIsEditing(!isEditing);
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setLoading(true);

  

    try {
      await axios.put(`https://citi-mobile-app.onrender.com/admin/edituser/${id}/${email}`, formData);
      setIsEditing(false);
    } catch (error) {
      console.error('Error updating customer details:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate(-1); // Navigate back to the previous page
  };

  const handleDelete = async () => {
    const user = JSON.parse(localStorage.getItem('user'));
    const email = user.email;

    if (window.confirm('Are you sure you want to delete this user?')) {
      try {
        await axios.delete(`https://citi-mobile-app.onrender.com/admin/deleteuser/${id}/${email}`);
        navigate('/AdminCustomerDetails'); // Redirect to customers list page after deletion
      } catch (error) {
        console.error('Error deleting user:', error);
      }
    }
  };

  if (!customerDetails) {
    return <div>Loading...</div>; // Show a loading indicator while fetching
  }

  return (
    <div className=" max-sm:mt-16 p-6 max-sm:p-0 ml-60 max-sm:ml-0">
      <button onClick={handleBack} className="mb-4">
        <FontAwesomeIcon icon={faArrowLeft} className="mr-2" />
        Back
      </button>

      <form className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4" onSubmit={handleSave}>
        <div className="grid grid-cols-2 max-sm:grid-cols-1 gap-6">
          {/* Customer Name */}
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="customerName">
              Customer Name
            </label>
            <div className="flex items-center max-sm:flex-col">
              <input
                type="text"
                id="customerName"
                name="firstName"
                value={formData.firstName || ''}
                readOnly={!isEditing}
                onChange={handleInputChange}
                className="border border-gray-300 rounded py-2 px-4 w-full"
              />
              <input
                type="text"
                id="lastName"
                name="lastName"
                value={formData.lastName || ''}
                readOnly={!isEditing}
                onChange={handleInputChange}
                className="border max-sm:mt-5 border-gray-300 rounded py-2 px-4 w-full"
              />
              <button type="button" onClick={handleEditClick} className="ml-2">
                <FontAwesomeIcon icon={faEdit} />
              </button>
            </div>
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="phoneNumber">
              Phone Number
            </label>
            <input
              type="text"
              id="phoneNumber"
              name="phoneNumber"
              value={formData.phoneNumber || ''}
              readOnly={!isEditing}
              onChange={handleInputChange}
              className="border border-gray-300 rounded py-2 px-4 w-full"
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="gender">
              Gender
            </label>
            <input
              type="text"
              id="gender"
              name="gender"
              value={formData.gender || ''}
              readOnly={!isEditing}
              onChange={handleInputChange}
              className="border border-gray-300 rounded py-2 px-4 w-full"
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="storeName">
            Store Name
            </label>
            <input
              type="text"
              id="storeName"
              name="storeName"
              value={formData.storeName || ''}
              readOnly={!isEditing}
              onChange={handleInputChange}
              className="border border-gray-300 rounded py-2 px-4 w-full"
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="storeType">
            Store Type
            </label>
            <input
              type="text"
              id="storeType"
              name="storeType"
              value={formData.storeType || ''}
              readOnly={!isEditing}
              onChange={handleInputChange}
              className="border border-gray-300 rounded py-2 px-4 w-full"
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="state">
            State
            </label>
            <input
              type="text"
              id="state"
              name="state"
              value={formData.state || ''}
              readOnly={!isEditing}
              onChange={handleInputChange}
              className="border border-gray-300 rounded py-2 px-4 w-full"
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="lga">
            Local Government Area
            </label>
            <input
              type="text"
              id="lga"
              name="lga"
              value={formData.lga || ''}
              readOnly={!isEditing}
              onChange={handleInputChange}
              className="border border-gray-300 rounded py-2 px-4 w-full"
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="city">
            City
            </label>
            <input
              type="text"
              id="city"
              name="city"
              value={formData.city || ''}
              readOnly={!isEditing}
              onChange={handleInputChange}
              className="border border-gray-300 rounded py-2 px-4 w-full"
            />
          </div>

          {/* Store Address */}
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="locality">
            Locality
            </label>
            <input
              type="text"
              id="locality"
              name="locality"
              value={formData.locality || ''}
              readOnly={!isEditing}
              onChange={handleInputChange}
              className="border border-gray-300 rounded py-2 px-4 w-full"
            />
          </div>

           {/* Store Address */}
           <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="gpsCode">
            GpsCode
            </label>
            <input
              type="text"
              id="gpsCode"
              name="gpsCode"
              value={formData.gpsCode || ''}
              readOnly={!isEditing}
              onChange={handleInputChange}
              className="border border-gray-300 rounded py-2 px-4 w-full"
            />
          </div>

           {/* Store Address */}
           <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="potentialpurchase">
            Potential purchase
            </label>
            <input
              type="text"
              id="potentialpurchase"
              name="potentialpurchase"
              value={formData.potentialpurchase || ''}
              readOnly={true}
              onChange={handleInputChange}
              className="border border-gray-300 rounded py-2 px-4 w-full"
            />
          </div>

           {/* Store Address */}
           <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="customerclass">
            Customer Class
            </label>
            <input
              type="text"
              id="customerclass"
              name="customerclass"
              value={formData.customerclass || ''}
              readOnly={true}
              onChange={handleInputChange}
              className="border border-gray-300 rounded py-2 px-4 w-full"
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="fieldagent">
              Sales Agent
            </label>
            <input
              type="email"
              id="fieldagent"
              name="fieldagent"
              value={formData.fieldagent || ''}
              readOnly={!isEditing}
              onChange={handleInputChange}
              className="border border-gray-300 rounded py-2 px-4 w-full"
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="referralID">
             Refferral ID
            </label>
            <input
              type="text"
              id="referralID"
              name="referralID"
              value={formData.referralID || ''}
              onChange={handleInputChange}
              className="border border-gray-300 rounded py-2 px-4 w-full"
            />
          </div>
         

          {/* Password */}
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="password">
              Password
            </label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password || ''}
              readOnly={!isEditing}
              onChange={handleInputChange}
              className="border border-gray-300 rounded py-2 px-4 w-full"
            />
          </div>

        </div>

        {/* Buttons */}
        <div className="flex items-center justify-between">
          <button
            type="button"
            onClick={handleBack}
            className="bg-gray-300 text-gray-700 py-2 px-4 rounded hover:bg-gray-400"
          >
            Cancel
          </button>

          <button
            type="button"
            onClick={handleDelete}
            className="bg-red-500 text-white py-2 px-4 rounded hover:bg-red-600 flex items-center ml-2"
          >
            <FontAwesomeIcon icon={faTrash} className="mr-2" />
            Delete
          </button>

          {isEditing && (
            <button
              type="submit"
              className="bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600 flex items-center"
              disabled={loading}
            >
              {loading ? <span className="loader mr-2"></span> : 'Save'}
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default AdminViewCustomer;
